import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  inject,
  signal,
} from '@angular/core';
import { PromotionCardComponent } from './components/promotion-card/promotion-card.component';
import SketchComponent from '../home/components/sketch/sketch.component';
import { PreparationScheduleComponent } from './components/preparation-schedule/preparation-schedule.component';
import { GuidePlanComponent } from './components/guide-plan/guide-plan.component';
import { ParticipantFaqComponent } from './components/participant-faq/participant-faq.component';
import { GalleryDto, GalleryService } from '@millionshow/api-client';
import { rxResource } from '@angular/core/rxjs-interop';
import { Icon } from '@millionshow/client-libs';
import { SeoService } from '../../services/seo.service';

import { GalleryVideoPlayer } from '@millionshow/client-libs';

@Component({
  selector: 'app-event-page',
  imports: [
    GalleryVideoPlayer,
    CommonModule,
    PromotionCardComponent,
    SketchComponent,
    PreparationScheduleComponent,
    GuidePlanComponent,
    ParticipantFaqComponent,

    Icon,
  ],
  templateUrl: './event.page.html',
  styleUrl: './event.page.css',
})
export default class EventPage {
  private readonly seoService = inject(SeoService);
  private readonly galleryService = inject<GalleryService>(GalleryService);

  selectedTab = signal<'promotion' | 'application' | 'preparation' | 'faq'>(
    'promotion'
  );

  @ViewChild('tabContainer') tabContainerRef!: ElementRef<HTMLDivElement>;

  /** Whether there are more tabs to scroll right */
  hasMoreTabs = signal(true);

  changeTab(tab: 'promotion' | 'application' | 'preparation' | 'faq') {
    this.selectedTab.set(tab);
    setTimeout(() => {
      const container = this.tabContainerRef?.nativeElement;
      if (!container) return;
      const activeBtn = container.querySelector('.tab.active') as HTMLElement;
      if (!activeBtn) return;
      const scrollTarget =
        activeBtn.offsetLeft +
        activeBtn.offsetWidth / 2 -
        container.offsetWidth / 2;
      container.scrollTo({ left: scrollTarget, behavior: 'smooth' });

      // Update hint icon state after scroll
      setTimeout(() => {
        const atEnd =
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth - 4;
        this.hasMoreTabs.set(!atEnd);
      }, 400);
    }, 0);
  }

  onTabScroll(event: Event) {
    const el = event.target as HTMLElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    this.hasMoreTabs.set(!atEnd);
  }

  constructor() {
    this.seoService.set({
      title: '행사안내',
      description:
        '밀리언쇼 행사 운영 안내, 참가자 가이드, 준비 일정, FAQ를 확인해보세요.',
      path: '/event',
    });
  }

  $latestVideo = rxResource({
    stream: () => {
      return this.galleryService.galleryControllerSearchV1({
        pageNo: 1,
        pageSize: 1,
        isExposed: true,
        type: 'VIDEO' as GalleryDto['type'],
        category: 'PROMOTION' as GalleryDto['category'],
        orderBy: 'displayDate',
        align: 'desc',
        sourceType: 'MILLIONSHOW' as const,
      });
    },
  });

  latestVideoData = computed(() => {
    const items = this.$latestVideo.value()?.items || [];
    return items.length > 0 ? items[0] : null;
  });

  youtubeEmbedUrl = computed(() => {
    const video = this.latestVideoData();
    if (!video || !video.videoLink) return '';
    return video.videoLink;
  });
}
